import script from "./myPasswordEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./myPasswordEdit.vue?vue&type=script&setup=true&lang=js"

import "./myPasswordEdit.vue?vue&type=style&index=0&id=165b415a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165b415a"]])

export default __exports__